<div class="ipadBorder" [class.noWebp]="noWebp">
  <div *ngIf="mode === 'static'" class="ipadBackground">
    <div class="background1"></div>
    <div class="background2"></div>
    <div class="sidePanel">
      <div class="sidePanelContent"></div>
    </div>
    <div class="livePreviewButton">
      <div class="button" (click)="activatePreview()">Live demo&nbsp;&nbsp;<span class="icon">a</span></div>
    </div>
  </div>
  <div *ngIf="mode === 'preview'" #preview class="preview">
    <iframe #previewFrame src="/assets/app/app.html?demo" class="iframe" [style.transform]="'scale('+getScaleFactor()+', ' + getScaleFactor() + ')'" [width]="(getIframeWidth())" [height]="(getIframeHeight())"></iframe>
  </div>
</div>
